module.exports = __webpack_public_path__ + "img/152.a0372316.jpg";